
import { defineComponent } from 'vue'

import Button from '@/components/Button.vue'
import Box from '@/components/Box.vue'
import Block from '@/components/Block.vue'
import Tile from '@/components/Tile.vue'
import BgBlur from '@/components/BgBlur.vue'
import Ok from '@/components/Done.vue'
import TargetTile from '@/components/TargetTile.vue'
import Selectel from '@/components/Selectel.vue'
import TileModal from '@/components/TileModal.vue'

export default defineComponent({
  name: 'Game',
  components: {
    'tp-box': Box,
    'tp-button': Button,
    'tp-block': Block,
    'tp-tile': Tile,
    'tp-bacground-blur': BgBlur,
    'tp-ok': Ok,
    'tp-target-tile': TargetTile,
    selectel: Selectel,
    'tile-modal': TileModal,
  },
  data: function () {
    return {
      size: 4,
      cells: [] as any,
      tiles: [] as any,
      currentValue: 0,
      items: [
        {
          type: '',
          value: 0,
          done: false,
          needValue: 0,
        },
        {
          type: '',
          value: 0,
          done: false,
          needValue: 0,
        },
        {
          type: '',
          value: 0,
          done: false,
          needValue: 0,
        },
      ],
      componentIndex: 0,
      levelType: 'gpu',
      levelValue: 2048,
      mainTarget: {} as any,
      isMerged: false as Boolean,
      debugTileValue: '',
      active: true as Boolean,
      freeCells: 16,
      touchStart: {} as any,
      touchPosition: {} as any,
      doneLevel: false as Boolean,
      debugValue: '2048',
      isHard: false,
      timer: null as any,
      gameTime: 0 as number
    }
  },
  computed: {
    zeroCells(): number {
      let counts = 0
      if (!this.cells) {
        return counts
      }

      if (this.cells.length < 1) {
        return counts
      }

      for (let row = 0; row < this.size; row++) {
        for (let col = 0; col < this.size; col++) {
          let value = this.cells[row][col].value
          if (parseInt(value) === 0) {
            counts++
          }
        }
      }

      return counts
    },
    hasStep(): boolean {
      let step = false

      if (this.cells.length < 1) {
        return true
      }

      for (let row = 0; row < this.size; row++) {
        for (let col = 0; col < this.size; col++) {
          let value = this.cells[row][col].value
          
          if (this.cells[row - 1] && this.cells[row-1][col] && this.cells[row-1][col].value === value) {
            step = true
          }

          if (this.cells[row + 1] && this.cells[row+1][col] && this.cells[row+1][col].value === value) {
            step = true
          }

          if (this.cells[row][col-1] && this.cells[row][col-1].value === value) {
            step = true
          }

          if (this.cells[row][col+1] && this.cells[row][col+1].value === value) {
            step = true
          }

        }
      }

      return step
    }
  },
  methods: {
    debug() {
      let v = parseInt(this.debugValue)
      this.items[0].needValue = v
      this.items[1].needValue = v
      this.items[2].needValue = v
    },
    onkeyup() {
      this.active = true
    },
    createEmptyCell(key: string) {
      return {
        key: key,
        value: 0,
        x: -1,
        y: -1,
        oldX: -1,
        oldY: -1,
      }
    },
    getCellKey(x: number, y: number) {
      return `${x}_${y}`
    },
    getEmptyCells() {
      let arr = []
      let key = 0
      for (let row = 0 as number; row < this.size; row++) {
        arr[row] = new Array<any>()
        for (let col = 0 as number; col < this.size; col++) {
          let cell = this.createEmptyCell(this.getCellKey(col, row))
          cell.x = col
          cell.y = row
          arr[row][col] = cell
          key++
        }
      }
      return arr
    },
    addTile(tile: any) {
      this.tiles[tile.x][tile.y].value = tile.value
      return tile
    },
    addRandomTile() {
      const fourProbability = 0.1
      let emptyCells = []
      let emptyTiles = []
      for (let row = 0; row < this.size; row++) {
        for (let col = 0; col < this.size; col++) {
          if (this.cells[row][col].value === 0) {
            emptyCells.push(this.cells[row][col])
          }

          if (this.tiles[row][col].value === 0) {
            emptyTiles.push(this.tiles[row][col])
          }
        }
      }

      const index = ~~(Math.random() * emptyCells.length)
      const cell = emptyCells[index]
      const tile = emptyTiles[index]
      const newValue = Math.random() < fourProbability ? 4 : 2

      cell.value = newValue
      tile.value = newValue
      tile.new = true
    },
    move(direction: number) {
      this.setOldCoord()
      this.isMerged = false

      // 0 -> left, 1 -> up, 2 -> right, 3 -> down
      for (let i = 0; i < direction; ++i) {
        this.rotateLeft()
      }

      this.moveLeft()

      for (let i = direction; i < 4; ++i) {
        this.rotateLeft()
      }

      this.clearOldTiles()

      for (let row = 0; row < this.size; row++) {
        for (let col = 0; col < this.size; col++) {
          let x = this.tiles[row][col].x
          let y = this.tiles[row][col].y
          let oldX = this.tiles[row][col].oldX
          let oldY = this.tiles[row][col].oldY
          let value = this.tiles[row][col].value

          if (value !== 0 && (x !== oldX || y !== oldY)) {
            this.isMerged = true
          }
        }
      }

      if (this.isMerged === true) {
        this.addRandomTile()
        this.getPoints()
      }
    },
    getTileByCoordIndex(x: number, y: number): number {
      for (let i = 0; i < this.tiles.length; i++) {
        if (this.tiles[i].x === x && this.tiles[i].y === y) {
          return i
        }
      }

      return -1
    },
    clearOldTiles() { //удалить
      for (let row = 0; row < this.size; row++) {
        for (let col = 0; col < this.size; col++) {
          this.tiles[row][col].new = false
        }
      }
    },
    moveLeft() {
      this.compress()
      this.merge()
    },
    rotateLeft() {
      const cells = [] as any
      const tiles = [] as any

      for (let row = 0; row < this.size; row++) {
        cells.push([])
        tiles.push([])
        for (let col = 0; col < this.size; col++) {
          cells[row][col] = this.cells[col][this.size - row - 1]
          cells[row][col].x = col
          cells[row][col].y = row

          tiles[row][col] = this.tiles[col][this.size - row - 1]
          tiles[row][col].x = col
          tiles[row][col].y = row
        }
      }

      this.cells = cells
      this.tiles = tiles
    },
    setOldCoord() {
      const cells = this.cells
      const newCells = this.getEmptyCells()
      const newTiles = this.getEmptyCells()

      for (let row = 0; row < this.size; row++) {
        for (let col = 0; col < this.size; col++) {
          let x = cells[row][col].x || 0
          let y = cells[row][col].y
          newCells[row][col] = cells[row][col]
          newCells[row][col].oldX = x
          newCells[row][col].oldY = y

          let tx = this.tiles[row][col].x
          let ty = this.tiles[row][col].y
          newTiles[row][col] = this.tiles[row][col]
          newTiles[row][col].oldX = tx
          newTiles[row][col].oldY = ty
        }
      }

      this.cells = newCells
      this.tiles = newTiles
    },
    compress() {
      const newCells = this.getEmptyCells()
      const newTiles = this.getEmptyCells()

      for (let row = 0; row < this.size; row++) {
        let colIndex = 0
        let colTilesIndex = 0
        for (let col = 0; col < this.size; col++) {
          if (this.cells[row][col].value !== 0) {
            newCells[row][colIndex] = this.cells[row][col]
            colIndex++
          }

          if (this.tiles[row][col].value !== 0) {
            newTiles[row][colTilesIndex] = this.tiles[row][col]
            colTilesIndex++
          }
        }
      }

      this.cells = newCells
      this.tiles = []
      this.tiles = newTiles
    },
    merge() {
      let isMerged = false
      for (let row = 0; row < this.size; row++) {
        for (let col = 0; col < this.size - 1; col++) {
          if (this.cells[row][col].value !== 0 && this.cells[row][col].value === this.cells[row][col + 1].value) {
            this.cells[row][col].value = this.cells[row][col].value * 2
            this.cells[row][col + 1].value = 0
          }

          if (this.tiles[row][col].value !== 0 && this.tiles[row][col].value === this.tiles[row][col + 1].value) {
            this.tiles[row][col].value = this.tiles[row][col].value * 2
            this.tiles[row][col + 1].value = 0
            this.tiles[row][col + 1].merged = true
            this.isMerged = true
            isMerged = true
          }
        }
      }
      this.compress()
    },
    onkeydown(e: any) {
      let direction = -1

      // 0 -> left, 1 -> up, 2 -> right, 3 -> down
      if (e.keyCode === 37 || e.keyCode === 65) {
        direction = 0
      } else if (e.keyCode === 38 || e.keyCode === 87) {
        direction = 1
      } else if (e.keyCode === 39 || e.keyCode === 68) {
        direction = 2
      } else if (e.keyCode === 40 || e.keyCode === 83) {
        direction = 3
      }

      this.moveEvent(direction)
    },
    moveEvent(direction: any) {
      let isActive = this.$store.getters.isActive || false
      if (isActive === false) {
        return
      }

      if (this.active === false) {
        return
      }

      this.active = false
      if (direction >= 0 && direction <= 4) {
        this.move(direction)
      }
    },
    getPoints() {
      this.currentValue = 0
      for (let row = 0; row < this.size; row++) {
        for (let col = 0; col < this.size; col++) {
          if (this.cells[row][col].value !== 0 && this.cells[row][col].value > this.currentValue) {
            this.currentValue = this.cells[row][col].value
          }
        }
      }

      this.items[this.componentIndex].value = this.currentValue

      this.isLose()

      this.nextLevel()
    },
    isTargetDone(index: number) {
      if (this.mainTarget.components[index].count === this.items[index].value) {
        return true
      }

      return false
    },
    isAllTargets() {
      let doneTargetsCount = 0
      let doneTargets = false
      for (let i = 0; i < this.items.length; i++) {
        if (this.isTargetDone(i) === true) {
          doneTargetsCount++
        }
      }
      
      if (doneTargetsCount === this.items.length) {
        doneTargets = true
      }

      return doneTargets
    },
    hasStep() {
      for (let i = 0; i < 4; ++i) {
        this.rotateLeft()
      }
    },
    isLose() {
      if (this.zeroCells <= 0 && this.hasStep === false) {
        clearTimeout(this.timer)
        this.$store.dispatch('setLoseStatus', true)
        this.endAndGo('/lose')
      }
    },
    endAndGo(path: string) {
      clearTimeout(this.timer)
      this.componentIndex = 0
      this.cells = this.getEmptyCells()
      this.tiles = this.getEmptyCells()
      this.$store.dispatch('setActiveGame', false)
      this.$store.dispatch('setGameStatus', false)
      this.$router.push(path)
    },
    nextLevel() {
      let needPoints = this.items[this.componentIndex].needValue
      if (this.currentValue >= needPoints) {
        this.doneLevel = true
        this.items[this.componentIndex].value = this.currentValue
        this.items[this.componentIndex].done = true
        //@ts-ignore
        if (window.ta) {
          //@ts-ignore
          ta('specials.2048.goal.completed', 1, {
            goalPoints: this.items[this.componentIndex].value,
            goalItemType: this.items[this.componentIndex].type
          })
        }
        this.cells = this.getEmptyCells()
        this.tiles = this.getEmptyCells()
        this.componentIndex++
        let component = this.items[this.componentIndex]
        if (!component && this.isAllTargets()) {
          setTimeout(() => {
            this.doneLevel = false
            this.$store.dispatch('setWinStatus', true)
            this.endAndGo('/end')
          }, 2000)
        }
        setTimeout(() => {
          this.doneLevel = false
          setTimeout(() => {
            if (component) {
              this.levelType = component.type
              this.levelValue = component.needValue
            }
            this.addRandomTile()
            this.addRandomTile()
          }, 1000)
        }, 2000)
      }
    },
    isActiveTile(type: any) {
      if (this.levelType === type) {
        return true
      }

      return false
    },
    incrimentTime() {
      this.$store.dispatch('incrementGameTime')
    },
    init() {
      this.cells = this.getEmptyCells()
      this.tiles = this.getEmptyCells()
      this.addRandomTile()
      this.addRandomTile()

      this.mainTarget = this.$store.getters.target

      if (!this.mainTarget) {
        const targets = this.$store.getters.targets || []
        this.mainTarget = targets[Math.floor(Math.random() * targets.length).toString()]
      }

      let component = this.mainTarget.components[this.componentIndex]
      if (component) {
        this.levelType = component.type
        this.levelValue = component.count
      }

      for (let i = 0; i < this.mainTarget.components.length; i++) {
        this.items[i].type = this.mainTarget.components[i].type
        this.items[i].needValue = this.mainTarget.components[i].count
      }

      if (this.mainTarget.isHard) {
        this.isHard = true
      }

      window.addEventListener('keydown', this.onkeydown)
      window.addEventListener('keyup', this.onkeyup)

      const sensitivity = 20
      document.addEventListener('touchstart', (e) => {
        this.touchStart = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY }
        this.touchPosition = { x: this.touchStart.x, y: this.touchStart.y }
      })

      document.addEventListener('touchmove', (e) => {
        this.touchPosition = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY }
      })

      document.addEventListener('touchend', (e) => {
        let d = {
          x: this.touchStart.x - this.touchPosition.x,
          y: this.touchStart.y - this.touchPosition.y,
        }

        // 0 -> left, 1 -> up, 2 -> right, 3 -> down
        if (Math.abs(d.x) > Math.abs(d.y)) {
          if (Math.abs(d.x) > sensitivity) {
            if (d.x > 0) {
              this.moveEvent(0)
            } else {
              this.moveEvent(2)
            }
          }
        } else {
          if (Math.abs(d.y) > sensitivity) {
            if (d.y > 0) {
              this.moveEvent(1)
            } else {
              this.moveEvent(3)
            }
          }
        }

        this.touchStart = null
        this.touchPosition = null

        this.active = true
      })


      this.$store.dispatch('flushGameTime')
      this.$store.dispatch('setActiveGame', true)

      this.timer = setInterval(this.incrimentTime, 1000);
    },
  },
  mounted() {
    if (this.$store.getters.isGame === false) {
      this.$router.push('/')
    }
    this.$store.dispatch('setWinStatus', false)
    this.$store.dispatch('setLoseStatus', false)
    this.init()
  },
})
